import React from 'react'

type VariantNotFoundPanelProps = {
  /** The variant id or locus the user navigated to. */
  label: string
}

/**
 * Shown in the right-side panel when a navigated variant/locus isn't an exact
 * match in the case VCF. Variant entry is a manual copy-paste step, so we show
 * a hard error with no nearby-variant suggestion: an entry either matches a
 * variant in this case exactly or it is an error (GEN-3294).
 */
const VariantNotFoundPanel: React.FC<VariantNotFoundPanelProps> = ({ label }) => (
  <div className="p-4 text-sm" data-testid="variant-not-found-panel" role="alert">
    <p className="text-error-600 font-medium">Variant not found</p>
    <p className="text-text-subtle mt-1">
      <span className="font-mono">{label}</span> is not an exact match in this case&apos;s VCF.
    </p>
    <p className="text-text-subtle mt-2 text-xs">
      Re-check the entry and try again. A variant must match this case exactly; no nearby variant is substituted.
    </p>
  </div>
)

export default VariantNotFoundPanel
